import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g transform="translate(4)">
      <path
        d="M0,4 L0,24.34 L12,32 L24,24.36 L24,4 L0,4 Z M22,6 L22,10 L18,10 C16.3431458,10 15,11.3431458 15,13 L15,18 L9,18 L9,13 C9,11.3431458 7.65685425,10 6,10 L2,10 L2,6 L22,6 Z M14.13,20 L12,22.52 L9.87,20 L14.13,20 Z M2,12 L6,12 C6.55228475,12 7,12.4477153 7,13 L7,19.7 L10.69,24.07 L8.11,27.13 L2,23.24 L2,12 Z M9.81,28.22 L12,25.62 L14.19,28.22 L12,29.61 L9.81,28.22 Z M15.89,27.13 L13.31,24.07 L17,19.7 L17,13 C17,12.4477153 17.4477153,12 18,12 L22,12 L22,23.24 L15.89,27.13 Z"/>
      <rect width="24" height="2" className="euiIcon__fillSecondary"/>
    </g>
  </svg>
);
